module.exports = __webpack_public_path__ + "img/alinoDetectTowerFollower.c5c671ab.webp";